import ShowcaseIcon from '../common/images-new/showcase-icon.svg'
import JournalIcon from '../common/images-new/journal-icon.svg'
import LearningIcon from '../common/images-new/learning-icon.svg'
import CommunityIcon from '../common/images-new/community-icon.svg'
import ShowcaseBlue from '../common/images-new/showcase-blue-icon.svg'
import JournalBlue from '../common/images-new/journal-blue-icon.svg'
import LearningBlue from '../common/images-new/learning-blue-icon.svg'
import CommunityBlue from '../common/images-new/community-blue-icon.svg'
import CheckedVbe from '../common/images-new/checked-blue.png';
import AnalyticsIcon from '../common/images-new/analytics-icon.svg'
import AnalyticsMBLIcon from '../common/images-new/analytics-blue-icon.svg'
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import { ReactComponent as NewShowcaseIcon } from '../common/images-new/showcaseIcon.svg';
import { ReactComponent as NewJournalIcon } from '../common/images-new/journalIcon.svg';
import { ReactComponent as NewDPtaskIcon } from '../common/images-new/DPtaskIcon.svg';
import { ReactComponent as NewTutorDashboardIcon } from '../common/images-new/tutordashboardIcon.svg';
import { ReactComponent as NewCommunityIcon } from '../common/images-new/communityIcon.svg';
import { ReactComponent as NewVBEIcon } from '../common/images-new/VBEIcon.svg';
import { ReactComponent as NewAnalyticsIcon } from '../common/images-new/analyticsIcon.svg';
import EqualizerOutlinedIcon from '@mui/icons-material/EqualizerOutlined';
export const dataNavlink = [
    {
        icon: ShowcaseIcon,
        mobileIcon: ShowcaseBlue,
        title: 'My Showcase',
        url: '/',
        member: true,
    },
    {
        icon: JournalIcon,
        mobileIcon: JournalBlue,
        title: 'My Journal',
        url: '/journal',
        member: true,
    },
    {
        icon: LearningIcon,
        mobileIcon: LearningBlue,
        title: 'DP Tasks',
        url: '/tasks',
        member: true,
    },
    {
        icon: LearningIcon,
        mobileIcon: LearningBlue,
        title: 'Tutor Dashboard',
        url: '/teaching',
    },
    {
        icon: CommunityIcon,
        mobileIcon: CommunityBlue,
        title: 'Community',
        url: '/community',
        member: true,
    },
    {
        icon: CheckedVbe,
        mobileIcon: CheckedVbe,
        title: 'VBE',
        url: '',
        member: true,
    },
    {
        icon: AnalyticsIcon,
        mobileIcon: AnalyticsMBLIcon,
        title: 'Analytics',
        url: '/analytics',
        member: true,
    },
]

export const dataNavbarlink = [
    {
        icon: NewShowcaseIcon,
        title: 'My Showcase',
        url: '/',
        member: true,
        active: true,
    },
    // {
    //     inactiveIcon: <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    //         <path d="M7.66658 12V13.3333H6.33325V12H0.999919C0.631732 12 0.333252 11.7015 0.333252 11.3333V0.666667C0.333252 0.29848 0.631732 0 0.999919 0H4.99992C5.79638 0 6.51132 0.349167 6.99992 0.902787C7.48852 0.349167 8.20345 0 8.99992 0H12.9999C13.3681 0 13.6666 0.29848 13.6666 0.666667V11.3333C13.6666 11.7015 13.3681 12 12.9999 12H7.66658ZM12.3333 10.6667V1.33333H8.99992C8.26352 1.33333 7.66658 1.93029 7.66658 2.66667V10.6667H12.3333ZM6.33325 10.6667V2.66667C6.33325 1.93029 5.73632 1.33333 4.99992 1.33333H1.66659V10.6667H6.33325Z" fill="#111822" />
    //     </svg>,
    //     activeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    //         <path d="M7.66658 12V13.3333H6.33325V12H0.999919C0.631732 12 0.333252 11.7015 0.333252 11.3333V0.666667C0.333252 0.29848 0.631732 0 0.999919 0H4.99992C5.79638 0 6.51132 0.349167 6.99992 0.902787C7.48852 0.349167 8.20345 0 8.99992 0H12.9999C13.3681 0 13.6666 0.29848 13.6666 0.666667V11.3333C13.6666 11.7015 13.3681 12 12.9999 12H7.66658ZM12.3333 10.6667V1.33333H8.99992C8.26352 1.33333 7.66658 1.93029 7.66658 2.66667V10.6667H12.3333ZM6.33325 10.6667V2.66667C6.33325 1.93029 5.73632 1.33333 4.99992 1.33333H1.66659V10.6667H6.33325Z" fill="#D71440" />
    //     </svg>,
    //     title: 'My Showcase1',
    //     url: '/',
    //     member: true,
    //     active: true,
    // },
    // {
    //     inactiveIcon: <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    //         <path d="M7.66658 12V13.3333H6.33325V12H0.999919C0.631732 12 0.333252 11.7015 0.333252 11.3333V0.666667C0.333252 0.29848 0.631732 0 0.999919 0H4.99992C5.79638 0 6.51132 0.349167 6.99992 0.902787C7.48852 0.349167 8.20345 0 8.99992 0H12.9999C13.3681 0 13.6666 0.29848 13.6666 0.666667V11.3333C13.6666 11.7015 13.3681 12 12.9999 12H7.66658ZM12.3333 10.6667V1.33333H8.99992C8.26352 1.33333 7.66658 1.93029 7.66658 2.66667V10.6667H12.3333ZM6.33325 10.6667V2.66667C6.33325 1.93029 5.73632 1.33333 4.99992 1.33333H1.66659V10.6667H6.33325Z" fill="#111822" />
    //     </svg>,
    //     activeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    //         <path d="M7.66658 12V13.3333H6.33325V12H0.999919C0.631732 12 0.333252 11.7015 0.333252 11.3333V0.666667C0.333252 0.29848 0.631732 0 0.999919 0H4.99992C5.79638 0 6.51132 0.349167 6.99992 0.902787C7.48852 0.349167 8.20345 0 8.99992 0H12.9999C13.3681 0 13.6666 0.29848 13.6666 0.666667V11.3333C13.6666 11.7015 13.3681 12 12.9999 12H7.66658ZM12.3333 10.6667V1.33333H8.99992C8.26352 1.33333 7.66658 1.93029 7.66658 2.66667V10.6667H12.3333ZM6.33325 10.6667V2.66667C6.33325 1.93029 5.73632 1.33333 4.99992 1.33333H1.66659V10.6667H6.33325Z" fill="#D71440" />
    //     </svg>,
    //     title: 'My Showcase2',
    //     url: '/myshowcase',
    //     member: true,
    //     active: false,
    // },
    {
        icon: NewJournalIcon,
        title: 'My Journal',
        url: '/journal',
        member: true,
        active: false,
    },
    {
        icon: NewDPtaskIcon,
        title: 'DP Tasks',
        url: '/tasks',
        member: true,
        active: false,
    },
    {
        icon: NewTutorDashboardIcon,
        title: 'Tutor Dashboard',
        url: '/teaching',
        active: false,
    },
    {
        icon: NewCommunityIcon,
        title: 'Community',
        url: '/community',
        member: true,
        active: false,
    },
    {
        icon: NewVBEIcon,
        title: 'VBE',
        url: '',
        member: true,
        active: false,
    },
    {
        icon: NewAnalyticsIcon,
        title: 'Analytics',
        url: '/analytics',
        member: true,
        active: false,
    },
]

{/* <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24" fill="#111822" className="pb-0.5">
            <path d="M7.5 21H2V9h5.5v12zM22 21h-5.5V3H22v18zM14.75 21h-5.5V13h5.5v8z" />
        </svg> */}